/**
 * Sends enquiry/EmailJS errors to the server to be written to a log file.
 * No local storage; all errors go to the API.
 */

const ERROR_LOG_API_URL = "https://api.amitywellness.com/api-log-error.php";

function serializeError(error) {
  if (!error) return { message: "Unknown error" };
  if (typeof error === "string") return { message: error };
  return {
    message: error.message || error.text || String(error),
    status: error.status,
    statusText: error.statusText,
    ...(error.response && {
      response:
        typeof error.response === "object"
          ? JSON.stringify(error.response)
          : String(error.response),
    }),
  };
}

/**
 * Send an error to the server log. No local storage.
 * @param {string} context - e.g. 'EmailJS'
 * @param {Error|object|string} error - thrown error or message
 * @param {object} [meta] - optional extra info (e.g. guest email, dates)
 */
export function appendError(context, error, meta = {}) {
  const site =
    (typeof window !== "undefined" && window.location && window.location.origin) ||
    "";
  const entry = {
    time: new Date().toISOString(),
    context,
    site,
    ...serializeError(error),
    ...(Object.keys(meta).length && { meta }),
    apiKey: process.env.REACT_APP_API_RETURNING_KEY || "",
  };

  try {
    const payload = JSON.stringify(entry);
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: "application/json" });
      navigator.sendBeacon(ERROR_LOG_API_URL, blob);
    } else {
      fetch(ERROR_LOG_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: payload,
        keepalive: true,
      }).catch(() => {});
    }
  } catch (_) {
    // ignore
  }
}
